// src/components/Contact.js
import React, { useState } from "react";
import { FaEnvelope, FaLinkedin, FaGithub, FaCode } from "react-icons/fa";

function Contact() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const [status, setStatus] = useState(""); // "", "sending", "success", "error"

  const handleChange = (e) => {
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("sending");

    try {
      // 🔧 BACKEND HOOK:
      // Replace this URL with your real backend (Node/Express, FastAPI, etc.)
      // that sends the email using Nodemailer / SES / anything.
      const res = await fetch("http://localhost:5000/api/contact", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });

      if (!res.ok) throw new Error("Network error");

      setStatus("success");
      setForm({ name: "", email: "", subject: "", message: "" });
    } catch (err) {
      console.error(err);
      setStatus("error");
    }
  };

  return (
    <div className="section-content contact-section">
      <div className="contact-header">
        <FaEnvelope className="contact-icon" />
        <h1>Let&apos;s Connect</h1>
        <p className="section-intro">
          Want to discuss data science, quant research, or a new project?  
          Drop a message below and it will land straight in my inbox.
        </p>
      </div>

      <div className="contact-grid">
        {/* LEFT: FORM */}
        <form className="contact-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="name">
              Name <span className="required">*</span>
            </label>
            <input
              id="name"
              name="name"
              type="text"
              required
              value={form.name}
              onChange={handleChange}
              className="contact-input"
              placeholder="Your name"
            />
          </div>

          <div className="form-group">
            <label htmlFor="email">
              Email <span className="required">*</span>
            </label>
            <input
              id="email"
              name="email"
              type="email"
              required
              value={form.email}
              onChange={handleChange}
              className="contact-input"
              placeholder="you@example.com"
            />
          </div>

          <div className="form-group">
            <label htmlFor="subject">Subject</label>
            <input
              id="subject"
              name="subject"
              type="text"
              value={form.subject}
              onChange={handleChange}
              className="contact-input"
              placeholder="How can I help?"
            />
          </div>

          <div className="form-group">
            <label htmlFor="message">
              Message <span className="required">*</span>
            </label>
            <textarea
              id="message"
              name="message"
              required
              rows={6}
              value={form.message}
              onChange={handleChange}
              className="contact-textarea"
              placeholder="Tell me a bit about what you have in mind..."
            />
          </div>

          <button
            type="submit"
            className="btn primary contact-submit"
            disabled={status === "sending"}
          >
            {status === "sending" ? "Sending..." : "Send Message"}
          </button>

          {status === "success" && (
            <p className="contact-status success">
              ✅ Message sent! I&apos;ll get back to you soon.
            </p>
          )}
          {status === "error" && (
            <p className="contact-status error">
              ⚠️ Something went wrong. Try again in a moment.
            </p>
          )}
        </form>

        {/* RIGHT: INFO + SOCIALS */}
        <div className="contact-info">
          <h3>Address &amp; Email</h3>
          <p className="contact-name">Parth Suri</p>
          <p>Delhi, India</p>
          <p>
            <a href="mailto:your.email@example.com" className="contact-email">
              parthsuri009@gmail.com
            </a>
          </p>

          <div className="contact-divider" />

          <h4>Find me online</h4>
          <div className="contact-socials">
            <a
              href="https://www.linkedin.com/in/parth-suri-150a96251/"
              target="_blank"
              rel="noreferrer"
            >
              <FaLinkedin />
            </a>
            <a
              href="https://github.com/PSURI1894"
              target="_blank"
              rel="noreferrer"
            >
              <FaGithub />
            </a>
            <a
              href="https://leetcode.com/u/PS1894/"
              target="_blank"
              rel="noreferrer"
            >
              <FaCode />
            </a>
          </div>

          <p className="contact-backend-note">
            This form is wired to a backend API, so your message gets delivered
            via email rather than vanishing into the void.
          </p>
        </div>
      </div>
    </div>
  );
}

export default Contact;
